export default __webpack_public_path__ + "static/media/CWEEpath.b635815e.png";